import ActionTypes from '../constants/ActionTypes';
import initialState from '../store/initialState';

export default (state = initialState.infra, action) => {
  switch (action.type) {
    case `${ActionTypes.CHECK_INFRA_ALLOCATION}_SUCCESS`:
      return {
        ...state,
        isReady: action.payload.isReady,
      };
    default:
      return state;
  }
};
